import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import backUpFR from './backUpTranslations/fr.json';

export const INITIAL_LANGUAGE = 'fr';

i18n
  .use(initReactI18next)
  .init({
    lng: INITIAL_LANGUAGE,
    fallbackLng: false,
    resources: { [INITIAL_LANGUAGE]: { translation: backUpFR } },
    keySeparator: false,
    nsSeparator: false,
    interpolation: { escapeValue: false },
    initAsync: false,
  })
  .catch(() => undefined);

export const loadTranslations = (locale: string, translations: Record<string, string>) => {
  i18n.removeResourceBundle(locale, 'translation');
  i18n.addResourceBundle(locale, 'translation', translations);
  return i18n.changeLanguage(locale);
};

export default i18n;
